import { render, staticRenderFns } from "./OutpatientReview.vue?vue&type=template&id=4570b9dd&scoped=true&"
import script from "./OutpatientReview.vue?vue&type=script&lang=js&"
export * from "./OutpatientReview.vue?vue&type=script&lang=js&"
import style0 from "./OutpatientReview.vue?vue&type=style&index=0&id=4570b9dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4570b9dd",
  null
  
)

export default component.exports